// react
import React from 'react';

export default function ProductDetailsSkeleton() {
    return (
        <div className="product-details-skeleton" aria-hidden="true">
            <div className="product-details-skeleton__row">
                <div className="product-details-skeleton__gallery">
                    <div className="skeleton-bone main-img" />
                    <div className="thumbs">
                        <div className="skeleton-bone thumb" />
                        <div className="skeleton-bone thumb" />
                        <div className="skeleton-bone thumb" />
                        <div className="skeleton-bone thumb" />
                    </div>
                </div>
                <div className="product-details-skeleton__info">
                    <div className="skeleton-bone title" />
                    <div className="skeleton-bone meta" />
                    <div className="skeleton-bone price" />
                    <div className="skeleton-bone desc-line skeleton-bone--w-90" />
                    <div className="skeleton-bone desc-line skeleton-bone--w-75" />
                    <div className="skeleton-bone desc-line skeleton-bone--w-60" />
                    <div className="actions">
                        <div className="skeleton-bone btn-skeleton" />
                    </div>
                </div>
            </div>
        </div>
    );
}
